import { render, staticRenderFns } from "./ElInputCurrency.vue?vue&type=template&id=59a1ceef&"
import script from "./ElInputCurrency.vue?vue&type=script&lang=js&"
export * from "./ElInputCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports